(() => {
  const HOUSE_ID = 'gooey-duck-house';
  const HOUSE_HASH = `#${HOUSE_ID}`;

  const rootUrl = () => window.GooeyDuck?.routes?.root || '/';
  const configuredHouseUrl = () => window.GooeyDuck?.routes?.house || rootUrl();
  const houseUrl = () => {
    const configured = String(configuredHouseUrl()).replace(/#.*$/, '');
    const root = String(rootUrl()).replace(/#.*$/, '');
    return configured === root ? `${root}${HOUSE_HASH}` : configured;
  };

  const isBackToHouseLink = link => {
    if (!(link instanceof HTMLAnchorElement)) return false;
    const label = link.textContent.trim().toLowerCase();
    return label === 'back to the house' || label === 'back to house';
  };

  const markHouse = () => {
    const house = document.querySelector('[data-gooey-experience="house"]');
    if (!house) return null;

    house.id = HOUSE_ID;
    house.style.scrollMarginTop = '24px';

    if (window.location.hash === HOUSE_HASH) {
      window.requestAnimationFrame(() => {
        house.scrollIntoView({ block: 'start', behavior: 'auto' });
      });
    }

    return house;
  };

  const rewriteBackLinks = (scope = document) => {
    const links = scope.querySelectorAll?.('.gooey-rescue-card__actions a, .gooey-rescue-dock__actions a') || [];
    links.forEach(link => {
      if (!isBackToHouseLink(link)) return;
      link.href = houseUrl();
      link.dataset.gooeyHouseReturn = 'true';
    });
  };

  const sync = (scope = document) => {
    markHouse();
    rewriteBackLinks(scope);
  };

  document.addEventListener('click', event => {
    const link = event.target instanceof Element ? event.target.closest('a') : null;
    if (!isBackToHouseLink(link)) return;
    link.href = houseUrl();
  }, true);

  document.addEventListener('gooey:experience:statechange', () => sync());
  document.addEventListener('gooey:experience:open', () => sync());
  document.addEventListener('shopify:section:load', event => sync(event.target));

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => sync(), { once: true });
  else sync();
})();
